import { AfterViewInit, Component, Input, ChangeDetectionStrategy } from "@angular/core";
import * as Highcharts from 'highcharts/highstock';
import {MatTabsModule} from '@angular/material/tabs';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollResultService } from "../../poll-result.service";
import { PollResult } from "../../poll-result.type";
@Component({
    selector: "closed-question-result-bar-chart",
    templateUrl: "./closed-question-result-bar-chart.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        TranslateModule
    ]
})
export class ClosedQuestionResultBarChartComponent implements AfterViewInit {
    
    @Input() results: PollResult;
    @Input() chartId: string
    constructor(
        private pollResultService: PollResultService,
        private translateService: TranslateService
    ) {}

    ngAfterViewInit(){
        const chartData: { name: string; y: number; color: string }[] = this.pollResultService.formatClosedPollResult(this.results.values)
        Highcharts.chart('closedQuestionBarResult'+this.chartId, this.resultChartConfig(chartData) as any)
    }

    resultChartConfig (chartData: { name: string; y: number; color: string }[]) {
        return {
            chart: {
                type: 'pie',
            },
            title: {
                text: ''
            },
            tooltip: {
                headerFormat: '',
                pointFormat: `<b>{point.name}</b>: {point.y} ${ this.translateService.instant('reporting_participation_distrib.people')} ({point.percentage:.1f}%)`
            },
            colors: [ "#F94144", "#277DA1", "#F9C74F", "#90BE6D", "#F8961E", "#4D908E", "#F9844A", "#43AA8B", "#577590", "#F3722C" ],
            legend: {
                title: {
                    text: 'Options <i style="font-size: 9px; padding-top: 5px' +
                        'font-weight: normal">('+ this.translateService.instant('poll_results_chart.hide_options') +')</i>',
                },
                width: '100%',
                margin: 40,
                itemStyle: {
                    color: '#6c757d',
                    fontWeight: 'normal',
                   
                }
            },
            series: [
                {
                    data: chartData,
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b><br>{point.percentage:.1f}%',
                        filter: {
                            operator: '>',
                            property: 'percentage',
                            value: 0
                        }
                    },
                    showInLegend: true,
                }
            ]
        }
      
    }
}